import React, { memo } from "react";
import { Link } from "react-router-dom";

interface FloatingButtonGroupButtonProps {
    onClick?: () => void;
    to?: string;
    children: React.ReactNode;
}

const FloatingButtonGroupButton: React.FC<FloatingButtonGroupButtonProps> = ({ onClick, children, to }) => {

    const classes = `block w-full px-4 py-2 text-sm text-left hover:bg-gray-100 cursor-pointer`

    if (to) {
        return (
            <Link to={to} role="menuitem" className={classes}>
                {children}
            </Link>
        )
    } else {
        return (
            <div role="menuitem" onClick={onClick} className={classes}>
                {children}
            </div>
        )
    }
}

export default memo(FloatingButtonGroupButton);
